import gql from 'graphql-tag';

// PKによる取得
export const GET_PLAN_INF = gql`
  query(
    $golf_group_code: String!
    $golf_code: String!
    $plan_id: ID!
  ) {
    getPlanInf(
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      plan_id: $plan_id
    ) {
      PlanInfList{
        plan_id
        golf_code
        plan_name
        plan_member_class
        closing_days
        closing_time
        cancel_policy
        cancel_valid_days
        cancel_valid_time
        share_flag
        share_confirm_days
        share_confirm_time
        request_flag
        player_min
        player_max
        guarantee_code
        round_code
        through_flag
        competition_flag
        cart_code
        caddie_flag
        lesson_flag
        meal_flag
        accommodation_flag
        benefit_flag
        detail
        plan_fee_min
        plan_fee_max
        release_start
        release_valid
        display_priority
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        tax_usage
        tax_others
        meal_flag_name
        caddie_flag_name
        cart_code_name
        guarantee_code_name
        round_code_name
        through_flag_name
        lesson_flag_name
      }
    }
  }
`;

// プランに対する枠を取得(予約カレンダー用)
export const GET_PLAN_CELL_LIST = gql`
  query(
    $golf_group_code: String!
    $golf_code: String!
    $member_no: String
    $play_date_from: String
    $play_date_to: String
    $cell_number:String
    $price_min_code: String
    $price_max_code: String
    $start_times_codes: [String]
    $style_codes: [String]
    $benefit_codes: [String]

  ) {
    getPlanCellList(
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      member_no: $member_no
      play_date_from: $play_date_from
      play_date_to: $play_date_to
      cell_number: $cell_number
      price_min_code: $price_min_code
      price_max_code: $price_max_code
      start_times_codes: $start_times_codes
      style_codes: $style_codes
      benefit_codes: $benefit_codes
    ) {
      PlanCellList{
        plan_id
        golf_code
        plan_name
        plan_member_class
        plan_member_class_code
        closing_days
        closing_time
        share_flag
        request_flag
        share_confirm_days
        share_confirm_time
        request_flag
        request_approval
        guarantee_code
        round_code
        through_flag
        competition_flag
        cart_code
        caddie_flag
        lesson_flag
        meal_flag
        accommodation_flag
        benefit_flag
        plan_fee_min
        plan_fee_max
        display_priority
        total_fee
        play_date
        reserve_status
        player_left
        cart_code_icon
        guarantee_code_icon
        round_code_icon
        meal_flag_icon
        caddie_flag_icon
        accommodation_flag_icon
        share_flag_icon
      }
      SoldOutCellList{
        plan_id
        golf_code
        plan_member_class
        plan_member_class_code
        share_flag
        request_flag
        request_approval
        total_fee
        play_date
        reserve_status
        player_left
      }
      AllSettingDays{
        month_day
        date_name
        date_type
      }
    }
  }
`;
// 時間選択画面データ取得用
export const GET_START_TIME_INITIALIZED_DATA = gql`
  query(
    $plan_id: String!
    $play_date: String!
    $reserve_no: String
  ) {
    getStartTimeInitializedData(
      plan_id: $plan_id
      play_date: $play_date
      reserve_no: $reserve_no
    ) {
      StartTimeList{
        cell_id
        plan_id
        course_code
        play_date
        play_start
        reserve_status
        player_left
        course_name
        player_min
        player_max
        reserve_no
        plan_member_class
        plan_member_class_code
        open_flag
      }
      PlanCellInf{
        plan_id
        plan_name
        detail
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        closing_days
        closing_time
        golf_name
        total_fee
        cancel_detail
        cart_code_icon
        guarantee_code_icon
        round_code_icon
        meal_flag_icon
        caddie_flag_icon
        accommodation_flag_icon
        share_flag_icon
      }
      CompanionListPlayDate{
        cell_id
        Companion {
            reserve_no
            class_no
            player_no
            cell_id
            member_no
            family_name
            given_name
            nickname
            email
            gender
            era
            score_level
            profile
            enthusiasm
            member_class
            visited_code
        }
      }
      golf_course_img_path
      AllSettingDays{
            month_day
            date_name
            date_type
      }
    }
  }
`;
// リクエスト時間選択画面データ取得用
export const GET_REQUEST_INITIALIZED_DATA = gql`
  query(
    $plan_id: String!
    $play_date: String!
  ) {
    getRequestInitializedData(
      plan_id: $plan_id
      play_date: $play_date
    ) {
        PlanCellInf{
            plan_id
            plan_name
            detail
            add_fee_2b_weekday
            add_fee_3b_weekday
            add_fee_2b_weekend
            add_fee_3b_weekend
            closing_days
            closing_time
            golf_name
            total_fee
            cancel_detail
            cart_code_icon
            guarantee_code_icon
            round_code_icon
            meal_flag_icon
            caddie_flag_icon
            accommodation_flag_icon
            share_flag_icon
        }
        CodeList{
            code_key
                code
                code_name
                code_key_name
                reserve1
                reserve2
                reserve3
                reserve4
                reserve5
                valid_flag
        }
        golf_course_img_path
        AllSettingDays{
            month_day
            date_name
            date_type
        }
    }
  }
`;
// プラン及び枠の情報を取得
export const GET_PLAN_CELL_INF = gql`
  query(
    $plan_id: String!
    $play_date: String
    $member_no: ID!
    $golf_group_code: String!
    $golf_code: String
    $target_date: String
  ) {
    getPlanCellInf(
      plan_id: $plan_id
      play_date: $play_date
      member_no: $member_no
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      target_date: $target_date
    ) {
      CellList {
        plan_id
        plan_name
        detail
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        closing_days
        closing_time
        golf_name
        total_fee
        cancel_detail
        cart_code_icon
        guarantee_code_icon
        round_code_icon
        meal_flag_icon
        caddie_flag_icon
        accommodation_flag_icon
        share_flag_icon
      }
      Profile{
        era
        family_name
        given_name
        nickname
        email
        score_level
        profile
        mobile_number
        gender
      }
      total_point{
        total_all
        total_normal
        total_limited_normal
        total_limited
        total_expected
      }
      valid_date{
        total_limited_normal
        total_limited
        expected_date
      }
    }
  }
`;
// 選択された枠の情報を取得
export const GET_SELECT_CELL_LIST = gql`
  query(
    $plan_id: String!
    $cell_id: [String]
    $member_no: ID!
    $golf_group_code: String!
    $golf_code: String
    $target_date: String
  ) {
    getSelectCellList(
      plan_id: $plan_id
      cell_id: $cell_id
      member_no: $member_no
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      target_date: $target_date
    ) {
      SelectCellList{
        plan_id
        plan_name
        detail
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        closing_days
        closing_time
        golf_name
        total_fee
        course_code
        play_start
        course_name
        cancel_detail
        cart_code_icon
        guarantee_code_icon
        round_code_icon
        meal_flag_icon
        caddie_flag_icon
        accommodation_flag_icon
        share_flag_icon
      }
      Profile{
        era
        family_name
        given_name
        nickname
        email
        score_level
        profile
        mobile_number
        gender
      }
      total_point{
        total_all
        total_normal
        total_limited_normal
        total_limited
        total_expected
      }
      valid_date{
        total_limited_normal
        total_limited
        expected_date
      }
      point_setting
    }
  }
`;

// プランに対する満席の枠を取得(予約カレンダー用)
export const GET_PLAN_SOLDOUT_LIST = gql`
  query(
    $golf_group_code: String!
    $golf_code: String!
    $play_date_from: String!
    $play_date_to: String!
  ) {
    getPlanSoldOutList(
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      play_date_from: $play_date_from
      play_date_to: $play_date_to
    ) {
      PlanCellList{
        plan_id
        golf_code
        plan_member_class
        share_flag
        request_flag
        request_approval
        total_fee
        play_date
        reserve_status
        player_left
      }
    }
  }
`;
